import axios from "axios";

export default {
  getTokens() {
    return axios.get('/sophia_token');
  }
}